import { render } from "./HistoryRecords.vue?vue&type=template&id=052dc6e6&scoped=true&ts=true"
import script from "./HistoryRecords.vue?vue&type=script&lang=ts"
export * from "./HistoryRecords.vue?vue&type=script&lang=ts"

import "./HistoryRecords.vue?vue&type=style&index=0&id=052dc6e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052dc6e6"]])

export default __exports__